import { CheckoutRepository } from './repositories/checkout'
import { CheckoutService } from './services/checkout'

const checkoutRepository = new CheckoutRepository()

export const checkoutService = new CheckoutService({
    checkoutRepository,
})
